import { render, staticRenderFns } from "./VerDetallePlanPreventivoModal.vue?vue&type=template&id=4ea50919&"
import script from "./VerDetallePlanPreventivoModal.vue?vue&type=script&lang=ts&"
export * from "./VerDetallePlanPreventivoModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4ea50919', component.options)
    } else {
      api.reload('4ea50919', component.options)
    }
    module.hot.accept("./VerDetallePlanPreventivoModal.vue?vue&type=template&id=4ea50919&", function () {
      api.rerender('4ea50919', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/HistoricoMantenimiento/VerDetallePlanPreventivoModal.vue"
export default component.exports